import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { useAuth } from '../context/AuthContext';
import standardLogo from '../assets/logo.svg';

const LoginPage = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const { login, error, clearError, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/dashboard';

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    clearError();

    try {
      await login(credentials);
      navigate(from, { replace: true });
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setCredentials(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="min-h-screen flex align-items-center justify-content-center surface-ground px-3">
      <div className="w-full" style={{ maxWidth: '420px' }}>
        <Card className="shadow-2">
          <div className="text-center mb-4">
            <img src={standardLogo} alt="LHRC" className="mb-3" style={{ height: '80px' }} />
            <h1 className="text-2xl font-bold text-primary mb-1">Documents Verification</h1>
            <p className="text-color-secondary m-0">Sign in to your account</p>
          </div>

          <div className="px-3">
            {error && (
            <Message
              severity="error"
              text={error}
              closable
              className="mb-4"
            />
          )}
          </div>
          <form onSubmit={handleSubmit} className="flex flex-column gap-3 px-3">
            <div className="field">
              <label htmlFor="username" className="block text-sm font-medium mb-2">
                Username
              </label>
              <InputText
                id="username"
                value={credentials.username}
                onChange={(e) => handleInputChange('username', e.target.value)}
                className="w-full"
                placeholder="Enter your username"
                required
                disabled={isLoading}
              />
            </div>

            <div className="field">
              <label htmlFor="password" className="block text-sm font-medium mb-2">
                Password
              </label>
              <div className="w-full">
                <Password
                id="password"
                value={credentials.password}
                onChange={(e) => handleInputChange('password', e.target.value)}
                className="w-full"
                inputClassName="w-full"
                placeholder="Enter your password"
                toggleMask
                feedback={false}
                pt={{iconField: {root: {style: { width: "100%" }}}, input: {style: { width: "100%" }}, root: {style: { width: "100%" }}}}   
                required
                disabled={isLoading}
                
              />
            </div>
            </div>

            <Button
              type="submit"
              label="Sign In"
              className="w-full"
              loading={isLoading}
              disabled={!credentials.username || !credentials.password}
            />
          </form>

          <div className="text-center mt-4">
            <p className="text-sm text-color-secondary m-0">Forgot your password? Contact your administrator.</p>
          </div>
        </Card>

        <div className="text-center mt-4">
          <p className="text-sm text-color-secondary m-0">© { new Date().getFullYear() } Legal and Human Rights Centre. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;